import { Button } from "@aidron/aidron-ds";
import { CustomHeading } from "../../../../../components/StyledComponents/styleComponents.index";
import { i18n } from "../../../../../translate/i18n";

const { t } = i18n;

const UserRegistrationSection = ({ actions, ctx, uiState }) => {

    const { onSubmitForm, handleSubmit } = actions || {};
    const { selectedRole, selectOptions, storesByRegion } = ctx || {};
    const { register, errors } = uiState || {};

    return (
        <div
            style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px solid #e9ecef"
            }}>
            <CustomHeading
            fontSize={["0.3rem", "0.9rem", "1.3rem"]}
            inlineSize={"fit-content"}
            >
            ➕ {t("registerNewUser")}
            </CustomHeading>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <input
                type="text"
                placeholder="Nome completo"
                {...register("fullName", { required: true })}
                style={{
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "14px"
                }}
            />
            {errors.fullName && (
                <span style={{ color: "red", fontSize: "12px" }}>
                Nome é obrigatório
                </span>
            )}

            <input
                type="email"
                placeholder="E-mail"
                {...register("email", { required: true })}
                style={{
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "14px"
                }}
            />
            {errors.email && (
                <span style={{ color: "red", fontSize: "12px" }}>
                E-mail é obrigatório
                </span>
            )}

            <input
                type="password"
                placeholder="Senha"
                {...register("password", { required: true })}
                style={{
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "14px"
                }}
            />
            {errors.password && (
                <span style={{ color: "red", fontSize: "12px" }}>
                Senha é obrigatória
                </span>
            )}

            <select
                {...register("role", { required: true })}
                style={{
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "14px",
                backgroundColor: "white"
                }}
            >
                <option value="">Selecione o papel</option>
                {selectOptions.map((role) => (
                <option key={role} value={role}>
                    {role}
                </option>
                ))}
            </select>
            {errors.role && (
                <span style={{ color: "red", fontSize: "12px" }}>
                Selecione um papel
                </span>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <label style={{ fontSize: "14px", fontWeight: 500 }}>
                Associe uma ou mais lojas
                </label>
                <div
                style={{
                    maxHeight: "250px",
                    overflowY: "auto",
                    border: "1px solid #e0e0e0",
                    borderRadius: "6px",
                    padding: "8px",
                    backgroundColor: "white"
                }}
                >
                {storesByRegion &&
                    Object.entries(storesByRegion).map(([region, stores]) => (
                    <div
                        key={region}
                        style={{
                        marginBottom: "12px",
                        paddingBottom: "12px",
                        borderBottom: "1px solid #e9ecef"
                        }}
                    >
                        <strong
                        style={{
                            marginBottom: "6px",
                            display: "block",
                            fontSize: "14px",
                            color: "#495057"
                        }}
                        >
                        {region}
                        </strong>
                        <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            gap: "6px",
                            paddingLeft: "8px"
                        }}
                        >
                        {stores.map((store) => (
                            <label
                            key={store.storeId}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "2px",
                                cursor: "pointer"
                            }}
                            >
                            <input
                                type="checkbox"
                                value={store.storeId}
                                {...register("stores")}
                                style={{ cursor: "pointer" }}
                            />
                            <span style={{ fontSize: "13px" }}>
                                {store.storeName}
                            </span>
                            </label>
                        ))}
                        </div>
                    </div>
                    ))}
                </div>
            </div>

            <Button
                label={"Registrar usuário"}
                type={"filled"}
                disabled={!selectedRole}
                onClick={handleSubmit(onSubmitForm)}
            />
            </div>
        </div>
    )
}

const UserRemovalSection = ({ actions, ctx }) => {

    const { setSelectedUser, handleRequestUserRemoval } = actions || {};
    const { selectOptions, selectedUser } = ctx || {};
    
   return (
        <div
            style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            padding: "20px",
            backgroundColor: "#fff5f5",
            borderRadius: "8px",
            border: "1px solid #ffe0e0"
            }}
        >
            <CustomHeading
            fontSize={["0.3rem", "0.9rem", "1.3rem"]}
            inlineSize={"fit-content"}
            >
            🗑️ Remover Usuário
            </CustomHeading>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <select
                style={{
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "14px",
                backgroundColor: "white"
                }}
                onChange={(e) => {
                const user = selectOptions?.find(u => u.userId === e.target.value);
                setSelectedUser(user || null);
                }}
            >
                <option value="">Selecione o usuário</option>
                {selectOptions?.map((user) => (
                <option key={user.userId} value={user.userId}>
                    {user.username}
                </option>
                ))}
            </select>

            <Button
                label={"Remover usuário"}
                type={"filled"}
                disabled={!selectedUser}
                onClick={handleRequestUserRemoval}
            />
            </div>
        </div>
    )
}

export const UserManagementSection = ({ actions, ctx, uiState }) => {
  
  const { 
    setSelectedUser, 
    handleRequestUserRemoval,
    onSubmitForm, 
    handleSubmit
  } = actions || {} ;

  const { 
    selectOptions, 
    selectedUser,
    selectedRole, 
    storesByRegion
  } = ctx || {};

  const { register, errors, activeSection } = uiState || {};

  const showRegistration = activeSection === 'registration' || activeSection === 'both';
  const showRemoval = activeSection === 'removal' || activeSection === 'both';
  const isBoth = activeSection === 'both';

  return (
    <div
      style={{
        display: isBoth ? "grid" : "block",
        gridTemplateColumns: isBoth ? "1fr 1fr" : undefined,
        gap: isBoth ? "30px" : undefined
      }}
    >
      {showRegistration && 
        <UserRegistrationSection 
            actions={{
                onSubmitForm: onSubmitForm,
                handleSubmit: handleSubmit
            }}
            ctx={{
                selectedRole: selectedRole,
                storesByRegion: storesByRegion,
                selectOptions: selectOptions[0] || []
            }}
            uiState={{
                register: register, 
                errors: errors
            }}
        />
      }

      {showRemoval && 
        <UserRemovalSection 
            actions={{
                setSelectedUser: setSelectedUser, 
                handleRequestUserRemoval: handleRequestUserRemoval
            }} 
            ctx={{
                selectOptions: selectOptions[1] || [],
                selectedUser: selectedUser
            }}/>
      }
    </div>
  );
};